export function isCompanionMode(mode?: string, slug?: string) {
  return mode === 'companion'
}
